import { useEffect } from 'react'
import { ArrowLeftIcon, ArrowRightIcon } from '@radix-ui/react-icons'

interface UndoRedoControlsProps {
  canUndo: boolean
  canRedo: boolean
  onUndo: () => void
  onRedo: () => void
  currentAction: string
  historyLength: number
}

export function UndoRedoControls({ 
  canUndo, 
  canRedo, 
  onUndo, 
  onRedo, 
  currentAction, 
  historyLength 
}: UndoRedoControlsProps) {
  
  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === 'z' && !e.shiftKey) {
        e.preventDefault()
        if (canUndo) onUndo()
      } else if ((e.metaKey || e.ctrlKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) {
        e.preventDefault()
        if (canRedo) onRedo()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [canUndo, canRedo, onUndo, onRedo])

  return (
    <div className="undo-redo-controls">
      <div className="undo-redo-buttons">
        <button
          className={`undo-btn ${!canUndo ? 'disabled' : ''}`}
          onClick={onUndo}
          disabled={!canUndo}
          title="Undo (Ctrl+Z)"
        >
          <ArrowLeftIcon width={16} height={16} />
        </button>
        <button
          className={`redo-btn ${!canRedo ? 'disabled' : ''}`}
          onClick={onRedo}
          disabled={!canRedo}
          title="Redo (Ctrl+Y)"
        >
          <ArrowRightIcon width={16} height={16} />
        </button>
      </div>
      <div className="history-info">
        <span className="current-action">{currentAction}</span>
        <span className="history-count">({historyLength} steps)</span>
      </div>
    </div>
  )
} 